import { render } from "./ViewProducts.vue?vue&type=template&id=25e5dd8e"
import script from "./ViewProducts.vue?vue&type=script&lang=js"
export * from "./ViewProducts.vue?vue&type=script&lang=js"

import "./ViewProducts.vue?vue&type=style&index=0&id=25e5dd8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__